module.exports = __webpack_public_path__ + "static/sport/swiper-2.c2deb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/swiper-2.png
// module id = TgOY
// module chunks = 0